<template>
    <section id="partners" class="py-4">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <!-- Client 2 - Bootstrap Brain Component -->
            <div>
              <div class="container">
                <div class="row justify-content-md-center">
                  <div class="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
                    <h2 class="fs-6 text-secondary mb-2 text-uppercase text-center">{{ $t('service.partners.title1') }}</h2>
                    <h2 class="mb-4 display-5 text-center">{{ $t('service.partners.title2') }}</h2>
                    <hr class="w-50 mx-auto mb-5 mb-xl-9 border-dark-subtle">
                    <h2 class="mb-4 display-5 text-center">{{ $t('service.partners.banks') }}</h2>

                  </div>
                </div>
              </div>

              <div class="container overflow-hidden">
                <div class="row">
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 10px 0" height="85" src="../../assets/images/partners/Pumb.png" alt="PUMB"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-2 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3">
                      <img style="margin: 12px 0" height="81" src="../../assets/images/partners/SenseBank.png" alt="Sense Bank"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3">
                      <img style="margin: 10px 0" height="85" src="../../assets/images/partners/Otp.png" alt="OTP"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3">
                      <img style="margin: 30px 0" height="45" src="../../assets/images/partners/Sf.png" alt="SF"/>

                    </div>
                  </div>
<!--                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">-->
<!--                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3">-->
<!--                      <img style="margin: 20px 0" height="65" src="../../assets/images/partners/Km.png" alt="KM"/>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3">
                      <img style="margin: 42px 0" height="21" src="../../assets/images/partners/Globus.png"
                           alt="Globus"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3">
                      <img style="margin: 42px 0" height="21" src="../../assets/images/partners/Creditagricole.png"
                           alt="Creditagricole"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3">
                      <img style="margin: 36px 0" height="31" src="../../assets/images/partners/Abank.png" alt="Abank"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3">
                      <img style="margin: 36px 0" height="33" src="../../assets/images/partners/Ukrsib.png"
                           alt="Ukrsib"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3">
                      <img style="margin: 43px 0" height="19" src="../../assets/images/partners/Alliance.png"
                           alt="Alliance"/>

                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3">
                      <img style="margin: 44px 0" height="17" src="../../assets/images/partners/Unex.png" alt="Unex"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3">
                      <img style="margin: 38px 0" height="27" src="../../assets/images/partners/Superium.png"
                           alt="Superium"/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container">
                <div class="row justify-content-md-center">
                  <div class="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
                    <hr class="w-50 mx-auto mb-5 mb-xl-9 border-dark-subtle">
                    <h2 class="mb-4 display-5 text-center">{{ $t('service.partners.nets') }}</h2>

                  </div>
                </div>
              </div>

              <div class="container overflow-hidden">
                <div class="row">
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3">
                      <img style="margin: 36px 0" height="33" src="../../assets/images/partners/nets/Allo.png"
                           alt="Алло"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3">
                      <img style="margin: 40px 0" height="25" src="../../assets/images/partners/nets/Eldorado.png"
                           alt="Eldorado"/>
                    </div>
                  </div>

                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 36px 0" height="33" src="../../assets/images/partners/nets/Volti.png"
                           alt="Volti"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3">
                      <img style="margin: 36px 0" height="33" src="../../assets/images/partners/nets/Juke.png"
                           alt="ЖЖУК"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 42px 0" height="21" src="../../assets/images/partners/nets/Tehnotop.png"
                           alt="Технотоп"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 45px 0" height="15" src="../../assets/images/partners/nets/Dmtehnika.png"
                           alt="DM Техніка"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 39px 0" height="27" src="../../assets/images/partners/nets/Expert.png"
                           alt="Expert"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 39px 0" height="27" src="../../assets/images/partners/nets/Compvsesvit.png"
                           alt="Комп’ютерний Всесвіт"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 39px 0" height="27" src="../../assets/images/partners/nets/Orbita.png"
                           alt="Орбіта"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 44px 0" height="17" src="../../assets/images/partners/nets/Tehnomarket.png"
                           alt="Техномаркет"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 20px 0" height="65" src="../../assets/images/partners/nets/33м2.png"
                           alt="33м2"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 31px 0" height="43" src="../../assets/images/partners/nets/Ringoo.png"
                           alt="Ringoo"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 20px 0" height="65" src="../../assets/images/partners/nets/Ttt.png"
                           alt="ТТТ"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 45px 0" height="15" src="../../assets/images/partners/nets/Samsung.png"
                           alt="Samsung"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 20px 0" height="65" src="../../assets/images/partners/nets/DeWise.png"
                           alt="DeWise"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 32px 0" height="41" src="../../assets/images/partners/nets/Sota.png"
                           alt="Sota"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 42px 0" height="21" src="../../assets/images/partners/nets/Smartshop.png"
                           alt="Smartshop"/>
                    </div>
                  </div>

                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 25px 0" height="55" src="../../assets/images/partners/nets/Boschsiemens.png"
                           alt="Bosch-Siemens"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 0px 0" height="105" src="../../assets/images/partners/nets/Moyo.png"
                           alt="Moyo"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 10px 0" height="85" src="../../assets/images/partners/nets/MT.png" alt="MT"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 39px 0" height="27" src="../../assets/images/partners/nets/Yabko.png"
                           alt="Ябко"/>
                    </div>
                  </div>

                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 43px 0" height="19" src="../../assets/images/partners/nets/Tehnoprostir.png"
                           alt="Технопростір"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 0px 0" height="105" src="../../assets/images/partners/nets/KTC.png"
                           alt="KTC"/>
                    </div>
                  </div>
                  <div class="partnerLogo col-6 col-md-6 col-xl-3 text-center my-2">
                    <div class="text-secondary bg-light px-4 py-3 px-md-3 py-md-0 px-lg-8 py-lg-3 text-center">
                      <img style="margin: 39px 0" height="27" src="../../assets/images/partners/nets/Appleroom.png"
                           alt="Apple Room"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>
<script>
export default {
  name: 'Partners'
}
</script>

<style scoped>
.partnerLogo {
  filter: grayscale(1);
}

.partnerLogo:hover {
  filter: grayscale(0);
}
</style>



// WEBPACK FOOTER //
// src/components/companyPage/company_partners.vue